import { FormFieldError } from '@/lib/form/FormFieldError';
import { FormattedNumberInput } from '@/components/shared/FormattedNumberInput';
import { Label } from '@/components/ui/label';

export const F = ({ form, name, label, type = 'text', required, placeholder, className, onChange, onValueChange, ...props }: any) => {
    return (
        <form.Field name={name}>
            {(field: any) => (
                <div className={`space-y-1.5 flex flex-col ${className || ''}`}>
                    <Label htmlFor={field.name} className="text-xs font-semibold text-slate-700 whitespace-normal">
                        {label} {required && <span className="text-destructive">*</span>}
                    </Label>
                    {type === 'number' ? (
                        <FormattedNumberInput
                            id={field.name}
                            value={field.state.value}
                            onValueChange={(val) => {
                                field.handleChange(val);
                                if (onChange) onChange({ target: { value: val } } as any);
                                if (onValueChange) onValueChange(val);
                            }}
                            placeholder={placeholder}
                            className="flex h-9 w-full rounded-md border border-slate-200 bg-white px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-slate-500 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-slate-950 disabled:cursor-not-allowed disabled:opacity-50"
                            {...props}
                        />
                    ) : (
                        <input
                            id={field.name}
                            type={type}
                            value={field.state.value || ''}
                            onChange={(e) => {
                                field.handleChange(e.target.value);
                                if (onChange) onChange(e);
                                if (onValueChange) onValueChange(e.target.value);
                            }}
                            placeholder={placeholder}
                            className="flex h-9 w-full rounded-md border border-slate-200 bg-white px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-slate-500 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-slate-950 disabled:cursor-not-allowed disabled:opacity-50"
                            {...props}
                        />
                    )}
                    <FormFieldError field={field} />
                </div>
            )}
        </form.Field>
    );
};
